import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload, IPayloadPagination } from '@network/models/global.model'
import {
  IUser,
  IGetUsersParams,
  ISickPayDayHour,
  IGetUserParams,
  IPostUserParams,
  IPutUserParams,
  IUpdateDirectDepositInformationParams,
  IDirectDepositInformation,
  IAddressInformation,
  IAddressInformationParams,
  IUserProfileData,
  IGetUserProfileParams,
} from '@network/models/user.model'
import {
  IPhoneType,
  IPostPhoneTypeParams,
} from '@network/models/phone-type.model'

export class UsersApi {
  constructor(private axios: AxiosService) {}

  getUsers = async (params?: IGetUsersParams) => {
    const response = await this.axios.get<IPayloadPagination<IUser[]>>(
      Endpoints.getUsers,
      params,
    )
    return response
  }

  getUser = async (id: number, params?: IGetUserParams) => {
    const response = await this.axios.get<IPayload<IUser>>(
      Endpoints.getUser(id),
      params,
    )
    return response
  }

  getUserProfile = async (id: number, params?: IGetUserProfileParams) => {
    const response = await this.axios.get<IPayload<IUserProfileData>>(
      Endpoints.getUserProfile(id),
      params,
    )
    return response
  }

  postUser = async (params: IPostUserParams) => {
    const response = await this.axios.post<IPayload<IUser>>(
      Endpoints.postUser,
      params,
    )
    return response
  }

  putUser = async (id: number, params: IPutUserParams) => {
    const response = await this.axios.put<IPayload<IUser>>(
      Endpoints.putUser(id),
      params,
    )
    return response
  }

  deleteUser = async (id: number) => {
    const response = await this.axios.delete<{}>(Endpoints.deleteUser(id))
    return response
  }

  getUserSickPayDayHourStats = async (id: number) => {
    const response = await this.axios.get<IPayload<ISickPayDayHour[]>>(
      Endpoints.getUserSickPayDayHourStats(id),
      {},
    )
    return response
  }

  updateUserAvatar = async (id: number, params: FormData) => {
    const response = await this.axios.post<IPayload<IUser>>(
      Endpoints.updateUserAvatar(id),
      params,
    )
    return response
  }

  checkUserPhoneType = async (params: IPostPhoneTypeParams) => {
    const response = await this.axios.post<IPayload<IPhoneType>>(
      Endpoints.checkUserPhoneType,
      params,
    )
    return response
  }

  getDirectDepositInformation = async (id: number) => {
    const response = await this.axios.get<IPayload<IDirectDepositInformation>>(
      Endpoints.getDirectDepositInformation(id),
      {},
    )
    return response
  }

  updateDirectDepositInformation = async (
    id: number,
    params: IDirectDepositInformation,
  ) => {
    const response = await this.axios.put<
      IPayload<IUpdateDirectDepositInformationParams>
    >(Endpoints.updateDirectDepositInformation(id), params)
    return response
  }

  getAddressInformation = async (id: number) => {
    const response = await this.axios.get<IPayload<IAddressInformation>>(
      Endpoints.getAddressInformation(id),
    )
    return response
  }

  updateAddressInformation = async (
    id: number,
    params: IAddressInformation,
  ) => {
    const response = await this.axios.put<IPayload<IAddressInformationParams>>(
      Endpoints.updateAddressInformation(id),
      params,
    )
    return response
  }
}
